import store from 'store'
import { sessionEnd, sessionParked } from 'redux/Sessions'
import i18n from 'i18n'
import { showSuccessSnackbar } from 'modules/GlobalEvents/EventDispatchers'

export const getActiveSessionIndex = (getState) => {
  const { activeSessionIndex } = getState().sessions

  return activeSessionIndex
}

export const getActiveSession = (getState) => {
  const { activeSessionIndex: activeId } = getState().sessions
  // validate session exists
  if (activeId < 0) return false
  // get session
  return getState().sessions.list[activeId]?.session
}

const getMergedSessions = (getState) => {
  return getState().sessions.merged.ids.map(
    (id) => getState().sessions.list[id],
  )
}

export const getMergedSessionsInstances = (getState) => {
  return getMergedSessions(getState).map((s) => s.session)
}

export const thereIsHoldTogglingSession = (getState) => {
  return getState()
    .sessions.list.filter(Boolean)
    .some((s) => s.holdToggling)
}

export const parkCall = (id, slot, end = false) => {
  store.dispatch(sessionParked(id, slot))

  showSuccessSnackbar(i18n.t('NOTIFICATIONS.PARKED', { slot }), 'park')

  if (end) {
    store.dispatch(sessionEnd({}, id))
  }
}
